import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faUser,
  faWallet,
  faCalendarCheck,
  faFileMedical,
  faUpload,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Logo } from '../components';
import { useLocation } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { useNavigate, Link } from 'react-router-dom';
import { useServiceCategory } from '../hooks/useServiceCategory';
import { api } from '../services/api';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: 'IRANSans, sans-serif',
  fontSize: '14px',
  padding: '8px 16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
  '& .fa-icon': {
    marginLeft: '4px',
    color: '#666',
  },
  '& span': {
    marginRight: '8px',
  },
  '&.Mui-disabled': {
    opacity: 0.6,
    color: '#999',
    pointerEvents: 'none',
    '& .fa-icon': {
      color: '#999',
    },
  },
}));

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [userInfo, setUserInfo] = useState({
    Fname: localStorage.getItem('Fname'),
    Lname: localStorage.getItem('Lname'),
    phoneNumber: localStorage.getItem('phoneNumber')
  });
  const open = Boolean(anchorEl);

  // استفاده از هوک useServiceCategory و دریافت وضعیت فعال بودن
  const isUploadEnabled = useServiceCategory();

  const fetchUserInfo = async () => {
    const key = localStorage.getItem('key');
    const phoneNumber = localStorage.getItem('phoneNumber');
    
    if (key && phoneNumber) {
      try {
        const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=1`);
        let data = response.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            return;
          }
        }
        
        if (data && data[0]) {
          const { Fname, Lname } = data[0];
          localStorage.setItem('Fname', Fname);
          localStorage.setItem('Lname', Lname);
          setUserInfo(prev => ({
            ...prev,
            Fname,
            Lname,
            phoneNumber
          }));
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    }
  };

  // Check for user info on mount and when phoneNumber changes
  useEffect(() => {
    const phoneNumber = localStorage.getItem('phoneNumber');
    if (phoneNumber && (!userInfo.Fname || !userInfo.Lname)) {
      fetchUserInfo();
    }
  }, [userInfo.phoneNumber, userInfo.Fname, userInfo.Lname]);

  // Also check when route changes
  useEffect(() => {
    fetchUserInfo();
  }, [location.pathname]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      icon: faUser,
      text: 'ویرایش اطلاعات کاربری',
      onClick: (e) => {
        e.preventDefault();
        navigate('/edirPro');
        handleClose();
      },
    },
    {
      icon: faWallet,
      text: 'کیف پول',
      onClick: (e) => {
        e.preventDefault();
        navigate('/walletpayment');
        handleClose();
      },
    },
    {
      icon: faCalendarCheck,
      text: 'گزارش نوبت',
      onClick: (e) => {
        e.preventDefault();
        navigate('/history');
        handleClose();
      },
    },
    {
      icon: faFileMedical,
      text: 'پاسخ پزشک',
      onClick: (e) => {
        e.preventDefault();
        navigate('/doctoronline');
        handleClose();
      },
    },
   /* {
      icon: faUpload,
      text: 'آپلود اطلاعات کاربری',
      disabled: !isUploadEnabled,
      onClick: !isUploadEnabled ? null : (e) => {
        e.preventDefault();
        navigate('/UploadFiles');
        handleClose();
      },
    },*/
    {
      icon: faSignOutAlt,
      text: 'خروج',
      onClick: (e) => {
        e.preventDefault();
        exitUser();
        handleClose();
      },
    },
  ];

  const renderUserSection = () => {
    if (!userInfo.phoneNumber) {
      return (
        <Link className='text-decoration-none quick-btn text-lg-right custom-button d-flex align-items-center'
        style={{ fontSize: '15px', direction: 'rtl' }}
        to="/Login">
          <span className={'w-auto'}>ورود</span>
        </Link>         
      );
    }

    const welcomeMessage = userInfo.Fname && userInfo.Lname
      ? `حساب کاربری ${userInfo.Fname} ${userInfo.Lname}`
      : 'در حال بارگذاری...';

    return (
      <div className="relative">
        <div
          onClick={handleClick}
          className="quick-btn text-lg-right custom-button d-flex cursor-pointer align-items-center"
          style={{ fontSize: '15px', direction: 'rtl' }}
        >
           <FontAwesomeIcon
            icon={faBars}
            className="ml-2"
            style={{ fontSize: '18px' }}
          />
          
          <span className={'w-auto'}>{welcomeMessage}</span>
        </div>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              minWidth: '200px',
              fontFamily: 'IRANSans, sans-serif',
              direction: 'rtl',
            },
          }}
        >
          {menuItems.map((item, index) => (
            <StyledMenuItem 
              key={index} 
              onClick={item.onClick}
              disabled={item.disabled}
              style={{ 
                cursor: item.disabled ? 'not-allowed' : 'pointer',
                opacity: item.disabled ? 0.6 : 1 
              }}
            >
              <FontAwesomeIcon
                icon={item.icon}
                className="fa-icon"
                style={{ 
                  fontSize: '16px',
                  color: item.disabled ? '#999' : '#666'
                }}
              />
              <span>{item.text}</span>
            </StyledMenuItem>
          ))}
        </Menu>
      </div>
    );
  };

  const exitUser = () => {
    localStorage.removeItem('phoneNumber');
    localStorage.removeItem('key');
    localStorage.removeItem('Fname');
    localStorage.removeItem('Lname');
    setUserInfo({
      Fname: null,
      Lname: null,
      phoneNumber: null
    });
    navigate('/');
  };

  return (
    <div className="main_header w-100 FooterHeaderBackgroundImage">
      <div className="container">
        <div className="menu_wrapper menu_sticky">
          <div className="mx-2 tophead d-block py-0">
            <div className="d-flex align-items-center justify-content-between pt-2 pb-2 flex-wrap">
              <div className="h-info text-right IRANSans_Medium d-flex align-items-center flex-wrap" style={{ '@media (max-width: 768px)': { justifyContent: 'center', width: '100%' } }}>
                <div className="ml-4" style={{ width: '120px', minWidth: '120px', '@media (max-width: 768px)': { margin: '0 auto' } }}>
                  <Logo className="img-fluid" alt="لوگو درمانگاه" />
                </div>
                <div className="d-flex flex-column align-items-end" style={{ '@media (max-width: 768px)': { width: '100%', marginTop: '10px', textAlign: 'end' } }}>
                  <h1
                    className="text-white mb-2"
                    style={{
                      fontSize: 'clamp(16px, 4vw, 24px)',
                      direction: 'rtl',
                      textAlign: 'right',
                      width: '100%',
                    }}
                  >
                    درمانگاه فوق تخصصی چشم پزشکی دکتر صلوتی
                  </h1>
                    <h6
                      className="text-white"
                      style={{
                        fontSize: 'clamp(8px, 1.5vw, 16px)',
                        direction: 'rtl',
                        textAlign: 'right',
                        marginTop: '4px',
                        marginBottom: '0',
                        fontFamily: 'IRANSans, sans-serif',
                        fontWeight: 'bold',
                        width: '100%',
                        lineHeight: '1.4',
                        letterSpacing: '0.5px',
                      }}
                    >
                      پشتیبانی نوبت اینترنتی : 6272898-0713 ( داخلی 6 )
                    </h6>
                  {/*<div className="d-flex flex-row align-items-end">
                    <h6
                      className="text-white mb-0"
                      style={{ fontSize: '14px', direction: 'rtl' }}
                    >
                      <FontAwesomeIcon
                        icon={faClock}
                        className="ml-2"
                        style={{ fontSize: '14px' }}
                      />
                      ساعت کاری : همه روزه شنبه تا چهارشنبه - 8 تا 20
                    </h6>
                    <span
                      className="text-white mx-3"
                      style={{ fontSize: '14px', direction: 'rtl' }}
                    >
                      <FontAwesomeIcon icon={faPhone} className="ml-2" />
                      01733277585 - 01744677585
                    </span>
                  </div>*/}
                </div>
              </div>
              <div style={{ '@media (max-width: 768px)': { width: '100%', marginTop: '10px', display: 'flex', justifyContent: 'center' } }}>
                {renderUserSection()}
              </div>
            </div>
          </div>

          <div
            id="navigation"
            className="of-drop-down of-main-menu"
            role="navigation"
          ></div>

          <div className="d-md-none mobile-nav-button" style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: '10px', padding: '10px 0' }}>
            <div className="d-flex align-items-center justify-content-between w-100 px-3">
              <img src="/Img/Logo.png" alt="لوگو" style={{ height: '40px' }} />
              <button id="of-trigger" className="icon-wrap" onClick={(e) => e.preventDefault()}>
                <FontAwesomeIcon icon={faBars} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};